import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthAndLocationGuard } from './Core/guards/auth.guard';
import { LandingGuard } from './Core/guards/landing.guard';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { SelectivePreloadingStrategy } from './Core/services/selective-preloading-strategy.service';
import { LandingModule } from './public-components/landing/landing.module';
// import { TracingService } from './Core/services/tracing.service';

const routes: Routes = [
  {
    //Initial page "welcome to Tasheel" and 4 product choices.
    path: 'landing',
    loadChildren:() => LandingModule, //initial load
    // loadChildren: () => import('./public-components/landing/landing.module').then((m) => m.LandingModule),
    canActivate: [LandingGuard],
  },
  {
    path: 'apply',
    loadChildren: () => import('./public-components/requirements/requirements.module').then((m) => m.RequirementsModule),
    canActivate : [LandingGuard],
    data: { preload: true }
  },
  {
    path: 'landing/requirments',
    redirectTo : 'apply',
    pathMatch: 'full'
  }, 
  {
    path: 'requirments',
    redirectTo: 'apply',
    pathMatch: 'full'
  }, 
  {
    path: 'P/:pid',
    redirectTo: 'apply/:pid',
    pathMatch: 'full'
  },
  {
    path: 'eligibility-calculator',
    loadChildren: () => import('./public-components/eligibility-calculator/eligibility-calculator.module').then((m) => m.EligibilityCalculatorModule),
    data: { preload: true } //preload
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    data: { preload: true } //preload
  },
  {
    path: 'contract/:lan',
    redirectTo: '/auth/contract/:lan',
  },
  {
    //Redirect - Enter civil id
    path: 'civil',
    redirectTo: '/auth/civil',
  },
  {
    path: 'geolocation',
    loadChildren: () => import('./geolocation/geolocation.module').then((x) => x.GeolocationModule)
  },
  {
    path: 'mobile',
    loadChildren: () => {
      //(<any>window)?.frontendTrace?.("** about to route to mobile module.. path = mobile/");
      return import('./mobile/mobile.module').then((m) => m.MobileModule)
    }
  },
  {
    path: 'dash',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthAndLocationGuard],
  },
  {
    path: 'application-engine',
    loadChildren: () => import('./application-engine/application-engine.module').then((m) => m.ApplicationEngineModule),
    canActivate: [AuthAndLocationGuard],
  },
  {
    path : 'decline',
    loadChildren: () => import('./public-components/rejected/rejected.module').then((m) => m.RejectedModule)
  },
  {
    path: 'application',
    loadChildren: () => import('./application/application.module').then( (m) => m.ApplicationModule),
    canActivate: [AuthAndLocationGuard],
  },
  {
    path: 'application/offer-lite',
    loadChildren: () => {
      //(<any>window)?.frontendTrace?.("** about to route to offer lite module..");
      return import('./application/offer-mod/offer-mod.module').then((m) => m.OfferModModule);
    }
  },
  {
    path: 'application/mobile',
    loadChildren: () => {
      //(<any>window)?.frontendTrace?.("** about to route to mobile module.. path = application/mobile");
      return import('./mobile/mobile.module').then((m) => m.MobileModule)
    }
  },
  {
    path: 'application/submit',
    loadComponent: () => {
      //(<any>window)?.frontendTrace?.("** about to route to app-submit component..");
      return import('./mobile/app-submit/app-submit.component').then((x) => x.AppSubmitComponent)
    }
  },
  {
    path: 'geo',
    loadChildren: () => import('./public-components/geolocation_branch/geolocation_branch.module').then((m) => m.GeoLocation_BranchModule),
  },
  {
    path: 'board-main',
    loadChildren: () => import('./boardmain/boardmain.module').then( (m) => m.BoardMainModule)
  },
  {
    path: 'cli-employment-info',
    loadChildren: () => import('./application-engine/credit-limit-increase/credit-limit-increase.module').then((m) => m.CreditLimitIncreaseModule),
  },
  {
    path: 'fc',
    loadChildren: () => import('./public-components/finance-contract/finance-contract.module').then((m) => m.FinanceContractModule)
  },
  {
    path: 'rc',
    loadChildren: () => import('./public-components/review-contract/review-contract.module').then((m) => m.ReviewContractModule)
  },
  {
    path: 'sayen',
    loadChildren: () => import('./sayen/sayen.module').then((m) => m.SayenModule),
  },
  {
    path: 'doc',
    loadChildren: () => import('./application/doc/doc.module').then((m) => m.DocModule),
  },
  {
    path: 'nafith',
    loadChildren: () => import('./nafith/nafith.module').then((m) => m.NafithModule),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then((m) => m.CheckoutModule),
  },
  {
    path: 'abc',
    loadChildren: () => import('./anonymous/anonymous.module').then((m) => m.AnonymousModule),
  },
  {
    path: 'cut',
    loadChildren: () => import('./anonymous/anonymous.module').then((m) => m.AnonymousModule),
  },
  {
    path: 'customer', //! UNUSED
    loadChildren: () => import('./public-components/checkout/checkout.module').then((m) => m.CheckoutModule)
  }, 
  {
    path: 'merchanthost', //! UNUSED
    loadChildren: () => import('./public-components/merchanthost/merchanthost.module').then((m) => m.MerchantHostModule),
  },
  {
    path: 'merchanthost-mobile', //! UNUSED
    loadChildren: () => import('./public-components/merchanthostmobile/merchanthostmobile.module').then((m) => m.MerchantHostMobileModule),
  },
  {
    path: 'merchantland', //! UNUSED
    loadComponent: () => import('./mobile/merchantland/merchantland.component').then((x) => x.MerchantlandComponent)
  },
  { 
    path: 'CT/:id', //! UNUSED
    loadChildren: () => import('./public-components/mobile-install/mobile-install.module').then((m) => m.MobileInstallModule),
  },
  {
    path: 'application/merchant', //! UNUSED
    loadChildren: () => import('./public-components/merchants/merchant.module').then( (m) => m.MerchantModule ),
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    //Default redirect
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule)
  // },
  {
    path: '',
    loadChildren: () =>
    {
      // const stack = new Error().stack;
      //(<any>window)?.frontendTrace?.(`** about to route to checkout module..${stack}`);
      return import('./checkout/checkout.module').then((m) => m.CheckoutModule)
    },
  },
  {
    path: ':sid',
    loadChildren: () => import('./public-components/landing/landing.module').then((m) => m.LandingModule),
    canActivate: [LandingGuard]
  }, 
  {
    path: ':lan/:pid',
    redirectTo: 'apply/:lan/:pid',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NotFoundComponent,
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadingStrategy})],
  exports: [RouterModule],
})
export class AppRoutingModule {
  // constructor(tracingService: TracingService) {
  //   tracingService.traceEvent(`App Routing Module: ${localStorage.getItem('lang')}`);
  // }
}
